<template>
  <div>
    <div style="margin-bottom: 15px;">
      <div class="box is-boxed" style="border: none; padding: 10px; margin-top: 15px;">
        <label for="" class="label">Sisa Waktu: </label>
        <hr style="margin: 0 -10px 17px;">
        <vcountdown v-if="teacher_question.status == 'O' && !isEmpty(teacher_question.dueDate)"
          :finished="teacher_question.dueDate"
        ></vcountdown>
        <span v-if="teacher_question.status != 'O'" class="has-text-success">SELESAI</span>
      </div>
    </div>

    <div class="card is-boxed" style="margin-bottom: 15px;">
      <header class="card-header">
        <p class="card-header-title">
          Jawaban:
        </p>
        <a href="" class="card-header-icon font-14" v-if="!edit && (teacher_question.status == 'O' && (isEmpty(selected_answer) || isEmpty(selected_answer.grade)))" :class="{'is-loading is-disabled': loading_submit_answer}" :disabled="loading_submit_answer" @click.prevent="edit = true">
          <i class="fas fa-edit"></i>&nbsp;Ubah
        </a>

        <a href="" class="card-header-icon font-14 has-text-primary" v-if="edit && (teacher_question.status == 'O' && (isEmpty(selected_answer) || isEmpty(selected_answer.grade)))" :class="{'is-loading is-disabled': loading_submit_answer}" :disabled="loading_submit_answer" @click.prevent="confirmSubmit">
          <i class="fas fa-save"></i>&nbsp;Simpan
        </a>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column">
            <div class="content">
              <txteditor :editText="edit" :onUpdate="(text) => { answer_data['answer'] = text }" :text="answer_data.answer" :onSelectedFile="onSelectedFileTxtEditor" :addons="['image', 'document', 'video', 'youtube', 'other']" :multiple_media="true" :selected_media_ids="answer_data.media_ids"></txteditor>
            </div>

            <div style="margin-top: 10px;">
              <br v-if="!isEmpty(answer_data.answer)">
              <div class="middle-content">
                <div class="tugas__content-timeline">
                  <div class="content" style="padding: 0; border: none; margin: 0;">
                    <div class="keterangan" style="margin: 0; width: 100%;">
                      <div class="file-download" v-for="(media, key) in selected_medias" :key="key" style="padding: 5px .65rem;" :style="key == 0 ? 'margin-top: 0 !important;' : 'margin-top: 7px !important;'">
                        <div class="columns is-vcentered is-gapless" style="margin: 0 auto; width: 100%;">
                          <div class="column is-narrow">
                            <icon-collection :media="media" size="is-24x24"></icon-collection>
                          </div>
                          <div class="column" style="line-height: 1; padding-left: 10px !important; padding-right: 10px !important;">
                            <a href="" @click.prevent="showPreview(media)" class="font-12">{{ media.name }}</a>
                          </div>
                          <div class="column is-narrow" v-if="edit">
                            <button class="button is-text has-text-danger" v-if="!isEmpty(auth) && ['O', 'A', 'M'].indexOf(group.memberRole) > -1" @click.prevent="removeMedia(media)">Hapus</button>
                          </div>
                          <div class="column is-narrow">
                            <button class="button is-text" v-if="!isEmpty(auth) && ['O', 'A', 'M'].indexOf(group.memberRole) > -1 && ['video', 'document', 'other'].indexOf(media.type) > -1" @click.prevent="download(media, group.id)">Unduh</button>
                          </div>
                          <div class="column is-narrow" v-if="edit">
                            <button class="button is-text has-text-danger" v-if="!isEmpty(auth) && ['O', 'A'].indexOf(group.memberRole) > -1" @click.prevent="deleteDocuments(media.id)"><span class="icon"><i class="fas fa-times-circle"></i></span></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-one-third" v-if="!edit">
            <div class="box is-bg-info has-text-centered">
              <p class="subtitle is-5 has-text-white">Nilai</p>
              <p class="title is-3 has-text-white">{{ !isEmpty(selected_answer) && !isEmpty(selected_answer.grade) ? selected_answer.grade : '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box is-boxed" style="margin-top: 24px;" v-if="!isEmpty(selected_answer) && (!isEmpty(selected_answer.feedback) || !isEmpty(annotated_files))">
      <div class="columns is-mobile" style="margin-bottom: 0;">
        <div class="column has-text-left">
          <p class="title is-6">
            <span>Feedback Pengajar</span>
          </p>
        </div>
      </div>
      <hr style="margin: 0 -20px 17px;">
      <div v-if="!isEmpty(annotated_files)">
        <div class="middle-content">
          <div class="tugas__content-timeline">
            <div class="content" style="padding: 0; border: none; margin: 0;">
              <div class="keterangan" style="margin: 0; width: 100%;">
                <div class="file-download" v-for="(media, key) in annotated_files" :key="key" style="padding: 5px .65rem;" :style="key == 0 ? 'margin-top: 0 !important;' : 'margin-top: 7px !important;'">
                  <div class="columns is-vcentered is-gapless" style="margin: 0 auto; width: 100%;">
                    <div class="column is-narrow">
                      <icon-collection :media="media" size="is-24x24"></icon-collection>
                    </div>
                    <div class="column" style="line-height: 1; padding-left: 10px !important; padding-right: 10px !important;">
                      <a href="" @click.prevent="previewAnnotatedFile(media.id)" class="font-12">{{ media.name }}</a>
                    </div>
                    <div class="column is-narrow">
                      <button class="button is-text has-text-primary" @click.prevent="previewAnnotatedFile(media.id)">Lihat</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" style="padding: 0 10px; margin-top: 10px;" v-if="!isEmpty(selected_answer.feedback)">
        <div class="column">
          <span v-html="selected_answer.feedback"></span>
        </div>
      </div>
    </div>

    <div class="card is-boxed" style="margin-bottom: 15px;">
      <header class="card-header">
        <p class="card-header-title">
          Anggota yang telah mengumpulkan
        </p>
      </header>
      <div class="card-content">
        <div>
          <div v-if="!isEmpty(answers)">
        <div class="columns is-vcentered is-mobile" style="padding: 0 10px; margin-bottom: 0;" v-for="(answer, key) in answers" :key="key">
          <div class="column is-narrow">#{{ key + 1 }}</div>
          <div class="column is-narrow is-hidden-mobile">
            <figure class="image is-24x24 is-circle" style="margin: 0;">
              <avatar v-if="group.type == 'ACADEMIC'" :avatar_url="!isEmpty(answer.groupMember.account) && !isEmpty(answer.groupMember.account.user) && !isEmpty(answer.groupMember.account.user.media) && !isEmpty(answer.groupMember.account.user.media.images) && !isEmpty(answer.groupMember.account.user.media.images.thumb) && !isEmpty(answer.groupMember.account.user.media.images.thumb.link) ? answer.groupMember.account.user.media.images.thumb.link : ''"></avatar>

              <avatar v-else :avatar_url="!isEmpty(answer.groupMember.user) && !isEmpty(answer.groupMember.user.media) && !isEmpty(answer.groupMember.user.media.images) && !isEmpty(answer.groupMember.user.media.images.thumb) && !isEmpty(answer.groupMember.user.media.images.thumb.link) ? answer.groupMember.user.media.images.thumb.link : ''"></avatar>
            </figure>
          </div>
          <div class="column">
            <span v-if="group.type == 'ACADEMIC'">{{ answer.groupMember.account.name }}</span>
            <span v-else>{{ answer.groupMember.user.name }}</span>
          </div>
        </div>

        <pagination v-if="!loading_get_answers" :dataProvider="dataProvider" :clickHandler="getAllAnswers"></pagination>

        <div v-if="loading_get_answers">
          <spinner-loading></spinner-loading>
        </div>
      </div>

      <div class="columns is-vcentered is-mobile" v-else>
        <div class="column">
          <p class="has-text-grey has-text-centered"><small>Data tidak ditemukan.</small></p>
        </div>
      </div>
        </div>
      </div>
    </div>

    <preview-modal v-if="!isEmpty(preview_media)" :onHide="() => preview_media = null" :media="preview_media"></preview-modal>
  </div>
</template>

<script>
import { TEACHER_QUESTION } from '~/consts';
import Countdown from '~/components/Countdown';
import TextEditor from '~/components/TextEditor';

export default {
  components: {
    'vcountdown': Countdown,
    'txteditor': TextEditor
  },

  props: {
    group: {
      type: Object,
      required: true
    },
    teacher_question: {
      type: Object,
      required: true
    }
  },

  mounted() {
    this.getMyAnswer()
    this.getAllAnswers(true);
  },

  data() {
    return {
      edit: false,
      loading_submit_answer: false,
      loading_get_answer: false,
      loading_get_answers: false,
      selected_medias: [],
      preview_media: null,
      selected_answer: null,
      answers: [],
      annotated_files: [],
      dataProvider: {
        page: {
          current: 1,
          limit: 100
        },
        sort: [
          {criteria: 'created_at', order: 'ASC'}
        ]
      },
      answer_data: {
        id: null,
        media_ids: [],
        answer: ''
      }
    }
  },

  methods: {
    getAllAnswers(refresh = false) {
      const vm = this;

      vm.loading_get_answers = true

      if (refresh) {
        vm.dataProvider.page['current'] = 1;
      }

      this.$axios.post(TEACHER_QUESTION.GET_ALL_ANSWERS(vm.teacher_question.id), {
        dataProvider: JSON.stringify(vm.dataProvider)
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let answers = data.data.data;
            if (!refresh) {
              answers = vm.answers.concat(answers);
            }

            vm.answers = answers;

            vm.dataProvider = data.data.dataProvider
          } else {
            toast.danger(data.applicationSystem.message);
          }

          vm.loading_get_answers = false
        })
        .catch(() => {
          vm.loading_get_answers = false
        })
    },
    removeMedia(media) {
      const vm = this;

      let medias = collect(this.selected_medias).filter((m) => m.id != media.id);
      this.selected_medias = medias.toArray();
      this.answer_data['media_ids'] = medias.pluck('id').toArray();
    },
    getMyAnswer() {
      const vm = this;

      vm.loading_get_answer = true

      this.$axios.post(TEACHER_QUESTION.GET_MY_ANSWER(vm.teacher_question.id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            if (!vm.isEmpty(data.data)) {
              let media_ids = collect(data.data.newMedias).pluck('id').toArray()

              vm.selected_answer = data.data;
              vm.answer_data = {
                id: data.data.id,
                media_ids: !vm.isEmpty(media_ids) ? media_ids : [],
                answer: data.data.answer
              }

              this.getAnnotatedFiles();

              vm.selected_medias = data.data.newMedias

              if (vm.isEmpty(vm.selected_answer)) {
                vm.edit = true;
              }
            } else {
              this.selected_answer = null;
              if (vm.teacher_question.status != 'C') {
                vm.edit = true;
              }
            }
          } else {
            toast.danger(data.applicationSystem.message);
          }

          vm.loading_get_answer = false
        }).catch(() => {
          vm.loading_get_answer = false
        })
    },
    onSelectedFileTxtEditor(medias) {
      const vm = this;

      if (!vm.isEmpty(medias)) {
        vm.answer_data['media_ids'] = collect(medias).pluck('id').toArray();
        vm.selected_medias = medias
      }
    },
    confirmSubmit() {
      const vm = this;

      this.$buefy.dialog.confirm({
        message: 'Pastikan jawaban anda benar, lanjutkan?',
        confirmText: 'Ya',
        cancelText: 'Batal',
        type: 'is-info',
        hasIcon: true,
        onConfirm: () => {
          vm.edit = false

          if (!this.isEmpty(this.selected_answer)) {
            this.updateAnswer()
          } else {
            this.submitAnswer()
          }
        }
      })
    },
    submitAnswer() {
      const vm = this;

      if (vm.loading_submit_answer) {
        return;
      }

      vm.loading_submit_answer = true

      this.$axios.post(TEACHER_QUESTION.ANSWER(vm.teacher_question.id), vm.answer_data)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            toast.info(data.applicationSystem.message);

            vm.getMyAnswer();
            vm.getAllAnswers(true);
          } else {
            toast.danger(data.applicationSystem.message);
            vm.edit = true
          }

          vm.loading_submit_answer = false
        }).catch(() => {
          vm.loading_submit_answer = false
        })
    },
    updateAnswer() {
      const vm = this;

      if (vm.loading_submit_answer) {
        return;
      }

      vm.loading_submit_answer = true

      this.$axios.post(TEACHER_QUESTION.UPDATE_ANSWER(vm.selected_answer.id), vm.answer_data)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            toast.info(data.applicationSystem.message);

            vm.getMyAnswer();
          } else {
            toast.danger(data.applicationSystem.message);
            vm.edit = true
          }

          vm.loading_submit_answer = false
        }).catch(() => {
          vm.loading_submit_answer = false
        })
    },
    showPreview(media) {
      if (['document', 'link'].indexOf(media.type) > -1) {
        if (media.type == 'link' && !this.isEmpty(media.link)) {
          window.open(media.link,'_blank');
        } else if (media.type == 'document' && !this.isEmpty(media.file) && !this.isEmpty(media.file.link) && media.storageType == null) {
          this.openDocument(media.file.link);
        } else if (media.storageType == 'google_drive' && media.type == 'document' && !this.isEmpty(media.values)) {
          window.open(media.values.webViewLink, "_blank");
        }
      } else if (['image', 'youtube', 'video'].indexOf(media.type) > -1) {
        this.preview_media = media
      }
    },
    async getAnnotatedFiles() {
      let {data} = await this.$axios.post(TEACHER_QUESTION.GET_ANNOTATED_FILES(this.selected_answer.id))

      if (data.applicationSystem.code == 0) {
        this.annotated_files = data.data
      }
    },
    previewAnnotatedFile(id) {
      let routeData = this.$router.resolve({
        name: `${this.$route.name}-preview`,
        params: { ...this.$route.params },
        query: {
          media: id,
          answer: this.selected_answer.id
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>
